import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, forwardRef } from 'react';
import { Dialog } from '../';
import * as Styles from './styles';
export const Drawer = forwardRef(function Drawer({ children, dir = 'ltr', backdrop = _jsx(Dialog.Backdrop, {}), header = _jsx(Dialog.Header, {}), content = _jsx(Dialog.Content, {}), ...rest }, ref) {
    return (_jsxs(Styles.Drawer, { backdrop: backdrop, "$dir": dir, ...rest, ref: ref, children: [header, content ? cloneElement(content, { children }) : children] }));
});
//# sourceMappingURL=index.js.map